import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, ApiError } from '../lib/api';

/**
 * Join by code. The code is checked before we navigate so a typo is answered
 * here, on the screen with the input on it, rather than by the player view.
 */
export function Join() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const clean = code.trim().toUpperCase();

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    if (!clean || checking) return;
    setError(null);
    setChecking(true);
    try {
      const session = await api.getSession(clean);
      navigate(`/play/${session.code}`);
    } catch (err) {
      setError(
        err instanceof ApiError && err.status === 404
          ? `No game with the code ${clean}.`
          : 'Could not reach the server.',
      );
      setChecking(false);
    }
  }

  return (
    <div className="centered">
      <div className="col" style={{ width: 'min(28rem, 100%)', gap: '0.75rem' }}>
        <form className="card col" onSubmit={submit}>
          <h1>Join a game</h1>
          <p className="muted" style={{ marginTop: 0 }}>
            Enter the game code shown on the TV.
          </p>

          <div className="field">
            <label htmlFor="code">Game code</label>
            <input
              id="code"
              value={code}
              onChange={(e) => {
                setCode(e.target.value.toUpperCase());
                setError(null);
              }}
              placeholder="ACDFHJ"
              autoCapitalize="characters"
              autoComplete="off"
              autoFocus
              maxLength={8}
              style={{ fontSize: '1.6rem', letterSpacing: '0.25em', textAlign: 'center' }}
            />
          </div>

          {error ? <p className="error-text">{error}</p> : null}

          <button className="btn btn-primary btn-lg" type="submit" disabled={!clean || checking}>
            {checking ? 'Checking…' : 'Join as player'}
          </button>

          {/* Whoever's setting up the TV or the host laptop starts here too. */}
          <div className="home-links">
            <button
              className="btn"
              type="button"
              disabled={!clean}
              onClick={() => navigate(`/board/${clean}`)}
            >
              Open TV board
            </button>
            <button
              className="btn"
              type="button"
              disabled={!clean}
              onClick={() => navigate(`/host/${clean}`)}
            >
              Open host control
            </button>
          </div>
        </form>

        <Link className="btn btn-ghost" to="/">
          ← Back
        </Link>
      </div>
    </div>
  );
}
